import axiosInstance from "../../../Utils/axiosInstance";
interface Payload {
    email: string;
    sendEmail: string;
    resend: boolean;
}
export const LoginApi = async (payload: Payload) => {
    try {
        const response = await axiosInstance.post(
            "/api/mm_manager/otp/generateOtp",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
interface logoutPayload {
    email: string;
}
export const LogoutApi = async (payload: logoutPayload) => {
    try {
        const response = await axiosInstance.post(
            "/api/mm_manager/logout",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
